import React from "react";
import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Modal } from "../../../components/modal/Modal";
import { Spacing } from "../../../theme/Spacing";
import { useTranslation } from "react-i18next";
import { Info } from "../../../components/Info";
import { Button } from "../../../components/Button";
import { useAtiraFormContext } from "../context/form-context";
import { TestIDs } from "../../../tests/types/testIds";

const DenyButton = styled(Button)`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.black};
  width: fit-content;
  height: 2.5rem;
  color: ${({ theme }) => theme.black};

  &:hover {
    background-color: ${({ theme }) => theme.black};
    color: ${({ theme }) => theme.white};
  }
`;

const ConfirmButton = styled(Button)`
  min-width: 5rem;
  height: 2.5rem;
`;

const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.s};
  list-style-type: disc;
  list-style-position: inside;

  li::marker {
    color: ${({ theme }) => theme.main};
  }
`;

type FormDeleteWarningModalProps = {
  loading: boolean;
  onConfirm: VoidFunction;
};

export const FormDeleteWarningModal: React.FC<FormDeleteWarningModalProps> = ({
  loading,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const { formDeleteVisible, setFormDeleteVisible } = useAtiraFormContext();

  return (
    <Modal
      zIndex={10000}
      open={formDeleteVisible}
      onClose={() => setFormDeleteVisible(false)}
      title={t("forms.delete.modal.title")}
    >
      <Flex flexDirection="column" alignItems="center" gap="m" width={"100%"}>
        <Info
          info={
            <StyledList>
              {Array.from({ length: 4 }, (_, index) => (
                <li key={index}>
                  {t(`forms.delete.modal.description-info-${index + 1}`)}
                </li>
              ))}
            </StyledList>
          }
          width={"100%"}
        />
        <Flex gap="xl">
          <DenyButton onClick={() => setFormDeleteVisible(false)}>
            {t("common.cancel")}
          </DenyButton>

          <ConfirmButton
            hover
            loading={loading}
            onClick={onConfirm}
            dataTestId={TestIDs.forms.form.actions.deleteModalConfirm}
          >
            {t("common.delete")}
          </ConfirmButton>
        </Flex>
      </Flex>
    </Modal>
  );
};
